const React = require('react');

const getDateRange = require('../../../utils/getDateRange');
const {INTERVAL_CUSTOM, INTERVAL_DAY, INTERVAL_MONTH} = require('../../../constants/intervals');

const CustomInterval = require('./components/CustomInterval');

module.exports = ({item, data, disabled, onChange, btnComponent: Button}) => {
  const {id, name} = item;
  const isCustom = id === INTERVAL_CUSTOM;
  const interval = data.interval || INTERVAL_DAY;

  const dateRange = getDateRange({
    interval: isCustom ? INTERVAL_MONTH : id,
  });

  const additionalData = isCustom
    // need testing to understand if it is nessesary to make this check
    ? {...dateRange, ...data}
    : {...data, ...dateRange};

  return (
    <Button
      disabled={disabled}
      checked={id === interval}
      onClick={() => {
        onChange({
          ...additionalData,
          interval: id,
        });
      }}
    >
      {isCustom ? (
        <CustomInterval
          disabled={disabled}
          data={additionalData}
          onChange={(state) => {
            onChange({
              ...state,
              interval: id,
            });
          }}
        />
      ) : name}
    </Button>
  );
};
